import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["google", "googleMapsInstance", "hit"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import { Component } from 'react';
import PropTypes from 'prop-types';
import { registerEvents, createListenersPropTypes, createFilterProps } from "./utils.js";
import { GeolocHitPropType } from "./propTypes.js";
import withGoogleMaps from "./withGoogleMaps.js";
var eventTypes = {
  onClick: 'click',
  onDoubleClick: 'dblclick',
  onMouseDown: 'mousedown',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseUp: 'mouseup'
};
var excludes = ['children'].concat(Object.keys(eventTypes));
var filterProps = createFilterProps(excludes);
export var Marker = /*#__PURE__*/function (_Component) {
  _inherits(Marker, _Component);

  var _super = _createSuper(Marker);

  function Marker() {
    _classCallCheck(this, Marker);

    return _super.apply(this, arguments);
  }

  _createClass(Marker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          google = _this$props.google,
          googleMapsInstance = _this$props.googleMapsInstance,
          hit = _this$props.hit,
          props = _objectWithoutProperties(_this$props, _excluded);

      this.instance = new google.maps.Marker(_objectSpread(_objectSpread({}, filterProps(props)), {}, {
        map: googleMapsInstance,
        position: hit._geoloc
      }));
      this.removeEventsListeners = registerEvents(eventTypes, this.props, this.instance);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.removeEventsListeners();
      this.removeEventsListeners = registerEvents(eventTypes, this.props, this.instance);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.instance.setMap(null);
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return Marker;
}(Component);

_defineProperty(Marker, "propTypes", _objectSpread(_objectSpread({}, createListenersPropTypes(eventTypes)), {}, {
  google: PropTypes.object.isRequired,
  googleMapsInstance: PropTypes.object.isRequired,
  hit: GeolocHitPropType.isRequired
}));

export default withGoogleMaps(Marker);